module.exports = __webpack_public_path__ + "static/media/ai.17ade557.png";